import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type AirLogoProps = ComponentProps<'svg'>;

export const AirLogo = memo(({ className, ...props }: AirLogoProps) => {
  return (
    <svg
      aria-hidden="true"
      className={cn('flex h-6 shrink-0', className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 30 12"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12.058 0c.844 0 1.64.82 1.64 2.71.006.864-.145 1.813-.36 2.771h3.651c.519 0 .869.519.676 1-.326.772-.591 1.386-.772 1.94-.169.483-.265.929-.265 1.398 0 .47.265.795.735.795 1.55 0 2.947-1.994 3.586-3.98-1.31-.429-1.91-1.291-1.91-2.345 0-1.374.977-2.049 1.87-2.06.976 0 1.759.638 1.759 2.204q0 .507-.072 1.042.24.008.506.005h2.448c.542 0 .892.58.639 1.061-.338.64-.663 1.29-.905 1.904-.205.555-.362 1.072-.374 1.53 0 .398.158.64.567.64 1.049 0 1.785-.615 2.544-1.459.278-.3.747-.349 1.012-.072.278.289.253.759 0 1.048-.88 1-2.109 1.868-3.556 1.868-1.374 0-2.062-.915-2.013-2.048.012-.603.192-1.302.481-2.024.125-.326.274-.661.435-1h-1.277q-.43-.001-.812-.035C21.524 9.51 19.659 12 17.363 12c-1.459 0-2.182-.82-2.182-2.18 0-.627.12-1.206.337-1.856.106-.32.239-.66.391-1.036h-2.935c-.088.32-.178.64-.266.95-.447 1.579-.965 3-1.182 3.495-.192.445-.47.626-.795.626-.53 0-.929-.47-.591-1.265.193-.422.724-1.77 1.182-3.289l.152-.513a43 43 0 0 0-4.156.232C5.49 10.217 4.238 12 2.002 12 .748 11.999 0 11.156 0 10.023c0-2.049 2.016-3.535 6.425-4.181C9.06 1.447 10.682 0 12.058 0M5.47 7.44c-2.588.499-4.023 1.356-4.023 2.536 0 .35.217.614.699.614 1.22 0 2.307-1.49 3.324-3.15m6.31-5.995c-.473 0-1.656 1.16-3.539 4.189a46 46 0 0 1 3.622-.152c.23-.952.394-1.908.387-2.772 0-1.084-.181-1.265-.47-1.265m9.127 2.157c-.265 0-.47.205-.47.687 0 .487.258.81.826.995q.053-.388.054-.742c0-.626-.181-.94-.41-.94M17.05 2.228c.555 0 1.025.458 1.025 1.024s-.47 1.024-1.025 1.024a1.025 1.025 0 0 1-1.026-1.024c0-.566.471-1.024 1.026-1.024"
      />
    </svg>
  );
});

AirLogo.displayName = 'AirLogo';
